import { useState, useEffect, useRef } from 'react'
import { UUID } from "uuidjs";
import useClient from './useClient'
import cloneDeep from 'lodash.clonedeep'

export default function useDictionary() {
  const [dictionary, setDictionary] = useState({})
  const { client, languageCode, defaultLanguageCode } = useClient()

  const uid = useRef(UUID.generate())

  const onDictionaryLoaded = (loaded) => {
    if (loaded) {
      //console.log(client.catalog)
      setDictionary(cloneDeep(client.catalog.dictionary))
    }
  };

  const getValue = (key) => {
    if (client?.catalog?.dictionary != null && client.catalog.dictionary[key] != null) {
      return client.catalog.dictionary[key] != null
        ? client.catalog.dictionary[key].translation[languageCode]?.length > 0
          ? client.catalog.dictionary[key].translation[languageCode]
          : (client.catalog.dictionary[key].translation[defaultLanguageCode]?.length > 0 ? client.catalog.dictionary[key].translation[defaultLanguageCode] : key)
        : key
    } else {
      return key
    }
  }

  useEffect(() => {
    if (client != null) {
      //console.log(client.catalog)
      client.addCallback('onDictionaryLoaded', uid.current, onDictionaryLoaded)
      setDictionary(cloneDeep(client.catalog.dictionary))
    }
    return () => {
      // ON UNMOUNT
      if (client != null) {
        client.removeCallback('onDictionaryLoaded', uid.current)
      }
    }
  }, [client])

  return {
    dictionary,
    getValue
  }
}
